export function numberToColor(id: number, opacity: number = null): string {
  // Minimum brightness (0...255)
  const minLimit: number = 70;
  // Maximum brightness (0...255)
  const maxLimit: number = 240;

  const hash = murmurHash3(id.toString());

  // Convert hash to RGB values
  let r = (hash & 0xff0000) >> 16;
  let g = (hash & 0x00ff00) >> 8;
  let b = hash & 0x0000ff;

  // Normalize and adjust RGB values
  const normalize = (c: number) => {
    // Scale to the range [0, 255] and adjust to fit between minLimit and maxLimit
    return minLimit + (c / 255) * (maxLimit - minLimit);
  };

  r = normalize(r);
  g = normalize(g);
  b = normalize(b);

  let color = opacity
    ? `rgb(${Math.round(r)},${Math.round(g)},${Math.round(b)},${opacity})`
    : `rgb(${Math.round(r)},${Math.round(g)},${Math.round(b)})`;

  return color;
}

function murmurHash3(str: string, seed: number = 0): number {
  let h1 = seed;
  for (let i = 0; i < str.length; i++) {
    let k1 = str.charCodeAt(i);
    k1 = Math.imul(k1, 0xcc9e2d51);
    k1 = (k1 << 15) | (k1 >>> 17);
    k1 = Math.imul(k1, 0x1b873593);
    h1 ^= k1;
    h1 = (h1 << 13) | (h1 >>> 19);
    h1 = Math.imul(h1, 5) + 0xe6546b64;
  }
  h1 ^= str.length;
  h1 ^= h1 >>> 16;
  h1 = Math.imul(h1, 0x85ebca6b);
  h1 ^= h1 >>> 13;
  h1 = Math.imul(h1, 0xc2b2ae35);
  h1 ^= h1 >>> 16;
  return h1 >>> 0;
}
